import { customTeamPageAllowed, customTeamCompanyHome } from "@/lib/team-permissions";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import { Link, Navigate, useRouterState } from "@tanstack/react-router";
import { useAuth } from "@/context/AuthContext";
import { useActiveTeam } from "@/lib/team-context";
import { cashierPageAllowed, isAccountEntryPath } from "@/lib/cashier-navigation";
import { AppShell } from "./AppShell";

export function CashierBoundary({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const { t } = useTranslation();
  const { ready, activeTeam } = useActiveTeam();
  const path = useRouterState({ select: state => state.location.pathname });
  if (isAccountEntryPath(path) || auth.status !== "authenticated") return children;
  if (!ready) return <p role="status">{t("cashier.loading_team")}</p>;
  const permissions = activeTeam?.permissions;
  if (activeTeam?.role !== "cashier" && permissions === undefined) return children;
  if (path === "/" || path === "/dashboard") return <Navigate to="/companies" replace />;
  const company = /^\/companies\/([^/]+)\/?$/.exec(path);
  if (company && company[1] !== "new") {
    const home = permissions === undefined ? `/companies/${company[1]}/facturas` : customTeamCompanyHome(company[1]!, permissions);
    if (home) return <Navigate to={home} replace />;
  }
  if (permissions !== undefined && customTeamPageAllowed(path, permissions) && (activeTeam?.role !== "cashier" || cashierPageAllowed(path))) return children;
  if (permissions === undefined && cashierPageAllowed(path)) return children;
  return <AppShell><h1 className="text-xl font-semibold">{t("cashier.denied_title")}</h1>
    <p className="my-4">{t(permissions === undefined ? "cashier.scope" : "teamRoles.denied")}</p>
    <Link to="/companies" className="underline">{t("cashier.select_company")}</Link></AppShell>;
}
